import {Component, computed, effect, inject, input} from '@angular/core';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';
import {TaxSelect} from '../../../../../api/models';
import {FormControl} from '@angular/forms';
import {TaxStore} from '../../services/tax-store';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'elcia-tax-dropdown',
  imports: [
    Dropdown,
    MultiDropdown,
    TranslatePipe,

  ],
  templateUrl: './tax-dropdown.html',
  styleUrl: './tax-dropdown.scss',
})
export class TaxDropdown {
  private taxStore = inject(TaxStore);

  taxes = computed<TaxSelect[]>(() =>
    this.taxStore.taxSelect().orderBy(t => t.name)
  );
  control = input.required<FormControl>();
  onControlBound = effect(() => {
    if (!this.control().value && this.taxes()) {
      const proposedTax = this.taxStore.proposedTax();
      if (proposedTax) this.control().setValue(proposedTax.id);
    }
  })
  isMulti = input<boolean>(false);
}
